import React from "react";
import "./Sections.scss";

function QA5() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          A flower design is at the heart of the Love in Verona collection. What
          inspired the collection’s floral motif?
        </p>
        <p className="interview__interview__copy">
          In the medieval period, the time of Romeo and Juliet, can you imagine
          the hills of Verona? It was all natural flowers. And in the
          Renaissance, the time of Shakespeare, flowers are everywhere and they
          represent romanticism, they are a symbol of love. I decided to take
          all this and put it in a bracelet, decorated with the renaissance
          flowers, and representing the perfect love.
        </p>
      </div>
    </section>
  );
}

export default QA5;
